//natives
import React from 'react';
import {Button} from '@material-ui/core';

export const ColTodosPedidos = (props) => {

    let array = [
        {
            name: 'NR_PC',
            label: 'Número Pedido'
        },
        {
            name: 'ID_PROD',
            label: 'Id Prod'
        },
        {
            name: 'CD_NUM',
            label: 'Cod Numérico'
        },
        {
            name: 'NM_PROD',
            label: 'Descrição'
        },
        {
            name: 'AB_COR1',
            label: 'Cor'
        },
        {
            name: 'DT_EMIS',
            label: 'Dt Emis'
        },
        {
            name: 'DT_ENTR',
            label: 'Dt Orig'
        },
        {
            name: 'DT_PREV_ENTRG',
            label: 'Dt Prevista'
        },
        {
            name: 'DT_AGENDADA',
            label: 'Dt Agenda'
        },
        {
            name: 'QT_ITEM',
            label: 'Qtd Item'
        },
        {
            name: 'QT_ENTRG',
            label: 'Qtd Entrega'
        },
        {
            name: 'QT_PEND',
            label: 'Qtd Pend'
        },
        {
            name: 'ID_PESSOA',
            label: 'Id Fornecedor'
        },
        {
            name: 'NM_PESSOA',
            label: 'Fornecedor'
        },
        {
            name: 'VM_UNIT',
            label: 'Custo Unit'
        },
        {
            name: 'VP_IPI',
            label: '% IPI'
        },
        {
            name: 'QT_PREV',
            label: 'Atraso Previsto'
        },
        {
            name: 'VL_TOT',
            label: 'Valor Total'
        },
        {
            name: 'VL_PEND',
            label: 'Valor Pend'
        },
        {
            name: 'QD_VOL_PEND',
            label: 'Qtd Volumes Pend'
        },
        {
            name: 'QT_AGENDA',
            label: 'Qtd Agenda'
        },
        {
            name: 'QT_VOL_AGENDA',
            label: 'Qtd Volumes Agend'
        },
        {
            name: 'DS_GEP',
            label: 'Grupo'
        },
        {
            name: 'CD_FAM',
            label: 'Família'
        },
        {
            name: 'DS_TIPO_PEDIDO',
            label: 'Tipo Pedido'
        },
        {
            name: 'CD_PAGTO',
            label: 'Cond Pagamento'
        },
        {
            name: 'CD_FIL_ENTRG',
            label: 'Filial'
        },
        {
            name: 'NM_DEPOSITO_ADIC',
            label: 'Depósito de Entrega'
        },
        {
            name: 'CD_ALFA',
            label: 'Código Alfa'
        },
        {
            name: 'IQ1',
            label: '%IQ1'
        },
        {
            name: 'NCM',
            label: 'NCM'
        },
        {
            name: 'VM_PENALZ_AGENDA',
            label: 'Valor Penalidade (R$)'
        },
        {
            name: 'VP_DESC',
            label: '% Desconto'
        },
        {
            name: 'VM_DESC',
            label: 'Valor Desconto (R$)'
        },
        {
            name: 'VL_LIQ_COM_DESC',
            label: 'Valor líquido (Valor R$ total com o desconto aplicado)'
        },
        {
            name: 'SOLIC_ANTEC',
            label: 'Solicitado antecipação (sim/não)'
        },
        {
            name: "PDF",
            label: 'PDF Português',
            options: {
                filter: false,
                download: false,
                customBodyRender: (value, tableMeta, updateValue) => (
                    <div>
                        {value &&
                            <Button 
                            letiant="contained" 
                            color="primary"
                            onClick={()=>{
                              props.props.router.push(`/pedidoCompra/${value.CD_FIL}/${value.NR_PC}/${value.LANGUAGE}`);
                            }}
                            >
                                PDF
                            </Button>
                        }
                    </div>
                  )
            }
        },
        {
          name: "PDF_INGLES",
          label: 'PDF Inglês',
          options: {
              filter: false,
              download: false,
              customBodyRender: (value, tableMeta, updateValue) => (
                  <div>
                      {value &&
                          <Button 
                          letiant="contained" 
                          color="primary"
                          onClick={()=>{
                            props.props.router.push(`/pedidoCompra/${value.CD_FIL}/${value.NR_PC}/${value.LANGUAGE}`);
                          }}
                          >
                              PDF
                          </Button>
                      }
                  </div>
                )
          }
        },
        {
            name: "ACOES",
            label: "Ações",
            options: {
                filter: false,
                download: false,
                customBodyRender: (value, tableMeta, updateValue) => (
                <div>
                    {value &&
                        <Button
                            letiant="contained"
                            color="primary"
                            onClick={(e)=>{props.cancelarPedido(value)}}
                            disabled={(value["ID_PERMITE_CANCEL"] === 'S')?false:true}
                        >
                            Cancelar
                        </Button>
                    }
                </div>
                )
            }
        }
    ];

    // remove coluna de pedidos levando em consideração a regra de negocio
    if (props.props.route.link === 'pendentes')
        array = array.filter(e=>(e.name !== "ACOES" && e.name !== "DT_AGENDADA"));
    
    // caso não houver filtro retorna todas as colunas acima
    return array;
};
